/**
 * Matches strings that have the form of a valid RFC 3339 string
 * (https://tools.ietf.org/html/rfc3339). Note that the string may not actually be a valid date
 * because the regex will match strings an with out of bounds month, date, etc.
 */
export const ISO_8601_REGEX = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|(?:(?:\+|-)\d{2}:\d{2}))?)?$/;

export const DATE_PERIOD_REGEX = /^\s?-?(\d+y)?\s?(\d+m)?\s?(\d+w)?\s?(\d+d)?\s?(\d+h)?\s?(\d+n)?\s?(\d+s)?$/;

/** Creates an array and fills it with values. */
export function range<T>(length: number, valueFunction: (index: number) => T): T[] {
   const valuesArray = Array(length);
   for (let i = 0; i < length; i++) {
      valuesArray[i] = valueFunction(i);
   }
   return valuesArray;
}
